/**
 * Class to handle custom-element
 * Add/Remove/Update cart with free item
 */
if (!customElements.get('cart-free-item')) {
  customElements.define('cart-free-item', class CartFreeItem extends HTMLElement {
  constructor() {
    super();
    this.onChange = this.onChange.bind(this);
    this.onChange = debounce(this.onChange, 500, true);
    this.maxSamples = parseInt(this.dataset.sampleMax);
    this.currentSample = this.querySelectorAll('input[checked]').length
    this.manageFree = this.dataset.manageFree; // manage free "sample" or "message"

    this.addEventListener('change', this.onChange);
    this.setSampleLimit()
  }

  /**
   * Debounce callback function
   * Trigger after change select value
   * @returns {Promise<void>}
   */
  async onChange(e) {
    const isChecked = e.target.checked;
    const sampleVId = e.target.dataset.vId;
    this.classList.add("u-pointer-events-none")

    this.elSelected = this.querySelectorAll(`#${e.target.id}`); // on mobile, because of splide, sevaral slide with same ID
    isChecked ? this.elSelected.forEach(el => el.setAttribute('checked', true)) : this.elSelected.forEach(el => el.removeAttribute('checked'));

    isChecked ? this.addToCart(sampleVId) : this.removeFromCart(sampleVId)
    isChecked && this.addDataLayer(e.target.dataset.sampleTitle)
  }

  getSectionsToRender() {
    return [{
      id: "main-cart-items",
      section: document.getElementById("main-cart-items").dataset.id,
      selector: ".js-contents",
    },
    {
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section'
    }
    ];
  }

  /**
   * Call on load or after select value change and currentFreeItemIndex is different from 0
   * @param updateContent {boolean} - In some case we don't want to update the cart content DOM
   * @returns {Promise<unknown>}
   */
  removeFromCart(sampleVId) {

    const formData = {
      'id': sampleVId,
      'quantity': 0,
      'sections_url': window.location.pathname,
      'sections': this.getSectionsToRender().map((section) => section.section)
    };

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        this.renderContents(data)
        this.classList.remove("u-pointer-events-none")
        this.currentSample--
        this.setSampleLimit()
      })
      .catch((error) => {
        console.error('Error:', error);
      })
  }

  addToCart(sampleVId) {

    const formData = {
      'items': [{
        'id': sampleVId,
        'quantity': 1,
        'properties': {
          '_is_sample': true,
        }
      }],
      'sections_url': window.location.pathname,
      'sections': this.getSectionsToRender().map((section) => section.section)
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        this.renderContents(data)
        this.classList.remove("u-pointer-events-none")
        this.currentSample++
        this.setSampleLimit()
      })
      .catch((error) => {
        console.error('Error:', error);
      })
  }

  // Ajout d'un dataLayer lors d'un ajout de sample dans le panier
  addDataLayer(sampleTitle) {
    const dataLayerAddSample = {
      event: 'choose_sample',
      item_name: sampleTitle,
    };
    window.dataLayer.push(dataLayerAddSample);
  }

  renderContents(parsedState) {
    const focusSnap =
      typeof window.captureCartFocus === 'function' ? window.captureCartFocus(document.activeElement) : null;

    this.getSectionsToRender().forEach((section => {

      if (!!section.section) {
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }

      // if (!!section.section) {
      //   const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      //   if (parsedState.sections && parsedState.sections[section.section]) {
      //     elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      //   }
      // }
    }));

    const updateCartRender = new CustomEvent(
      'update-cart-render',
    );
    document.dispatchEvent(updateCartRender);

    if (typeof window.scheduleRestoreCartFocus === 'function') {
      window.scheduleRestoreCartFocus(focusSnap);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  // limit maximum choose of samples
  setSampleLimit() {

    if (this.manageFree === "sample") {
      this.elCartFreeItem = document.querySelectorAll('[data-cart-free-item]')
      this.elSampleInCart = document.querySelectorAll('[data-free-sample]')

    } else if (this.manageFree === "message") {

      this.elCartFreeItem = document.querySelectorAll('[data-cart-free-message]')
      this.elSampleInCart = document.querySelectorAll('[data-free-message]')
    }


    this.sampleInCart = []

    this.elSampleInCart.forEach(product => {
      this.sampleInCart.push(product.dataset.productid)
    })

    if (this.elSampleInCart.length < this.maxSamples) {
      this.elCartFreeItem.forEach(el => el.classList.remove('u-opacity-70', "u-pointer-events-none"))
    } else {
      this.elCartFreeItem.forEach(el => {
        if (!this.sampleInCart.includes(el.dataset.id)) el.classList.add('u-opacity-70', "u-pointer-events-none")
      })
    }
  }

  });
}